import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type CreateScimApiKeyMutationVariables = GraphQLTypes.Exact<{
  input?: GraphQLTypes.InputMaybe<GraphQLTypes.CreateScimApiKeyInput>;
}>;

export type CreateScimApiKeyMutationResult = { __typename?: 'Mutation' } & {
  createScimApiKey?: GraphQLTypes.Maybe<
    { __typename?: 'CreateScimApiKeyPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'path'>>>;
    }
  >;
};

export const CreateScimApiKeyDocument = gql`
  mutation createScimApiKey($input: CreateScimApiKeyInput) {
    createScimApiKey(input: $input) {
      errors {
        path
      }
    }
  }
`;
